<template>
  <div class="Love">
      <div class="page-module">
        <header class="index-head">
            <p class="name">大家都爱看</p>
            <p class="more">更多 ></p>
        </header>
        <div class="content">
          <div v-for="(item,index) in everyonelikelist" :key="index"  @click="routedetails(item.innerid)">
            <ReportCard :item="item" ></ReportCard>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import ReportCard from './ReportCard'
export default {
  name: 'Love',
  props: ['everyonelikelist'],
  data () {
    return {}
  },
  mounted () {},
  methods: {
    routedetails(innerid) {
      this.$parent.routerDetails(innerid)
    },
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
      ReportCard
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.Love {
  .page-module {
    padding-bottom: 20px;
  }
}
</style>